import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';

import Dashboard from './Dashboard';

const DashboardContainer = props => (
  <Provider store={store}>
    <Dashboard id={props.id} {...props} />
  </Provider>
);

export default DashboardContainer;
